export default __webpack_public_path__ + "static/media/manufactory-costa-rica.9da2b571.jpg";